import { Box, CircularProgress, Grid, Theme, Typography } from "@mui/material";
import {
  AccountBalanceWallet,
  CheckCircle,
  TrendingUp,
  Paid
} from "@mui/icons-material";
import { useTheme } from "@mui/material";

import { KpiCard } from "../../programmeDashboard/components/KpiCard";
import { useStates } from "../hooks/usestates";

const getIcon = (label: string) => {
  if (label.includes("Total Planned")) return <AccountBalanceWallet fontSize="large" />;
  if (label.includes("Committed")) return <CheckCircle fontSize="large" />;
  if (label.includes("Raised")) return <TrendingUp fontSize="large" />;
  if (label.includes("Actual")) return <Paid fontSize="large" />;
  return <AccountBalanceWallet fontSize="large" />;
};

const getIconColor = (label: string, theme: Theme) => {
  if (label.includes("Total Planned")) return theme.palette.success.main;
  if (label.includes("Committed")) return theme.palette.info.main;
  if (label.includes("Raised")) return theme.palette.error.main;
  if (label.includes("Actual")) return theme.palette.primary.main;
  return theme.palette.primary.main;
};

export const InvestmentMetricsSection = () => {

  const theme = useTheme();
  const { data: metrics, isLoading, isError, error } = useStates();

  if (isLoading) {
    return (
      <Box
        height="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        gap={2}
      >
        <CircularProgress />
      </Box>
    )
  };

  if (isError) {
    return (
      <Box
        height="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        gap={2}
      >
        <Typography variant="h6" color="error">
          {error?.message || "Error loading data."}
        </Typography>
      </Box>
    )
  };


  return (
    <Grid container spacing={2}>
      {metrics.map((metric, index) => (
        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
          <KpiCard
            label={metric.label}
            value={metric.value}
            icon={getIcon(metric.label)}
            iconColor={getIconColor(metric.label, theme)}
            subValue={metric.subValue}
            // variance={metric.variance}
            // varianceType={metric.varianceType}
          />
        </Grid>
      ))}
    </Grid>
  );
};

